import { COLOR, FONT_SIZE } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const LIList = styled.li<{ isActive?: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${COLOR.GRAY1000.code};
  border-bottom: 2px solid ${({ isActive }) => (isActive ? COLOR.YELLOW900.code : COLOR.GRAY100.code)};

  > a {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

export const DivItem = styled.div<{ isActive?: boolean }>`
  font-size: ${FONT_SIZE.XXS}px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  ${({ isActive }) => !isActive && `opacity: 0.6;`}
`;
